import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
import { finalize, Subject, takeUntil } from 'rxjs'
import { MenuModel } from 'src/app/models/menu.model'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { DialogMenuComponent } from './dialog-menu/dialog-menu.component'

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenusComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>()
  isLoading = true
  kitchenMenus: MenuModel[] = []
  displayedColumns: (keyof MenuModel | 'modificar' | 'eliminar')[] = [
    'nombreMenu',
    'descripcion',
    'modificar',
    'eliminar'
  ]

  dataSource = new MatTableDataSource<any>([])

  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    this.dataSource.paginator = paginator
  }

  @ViewChild(MatSort) sort!: MatSort
  @ViewChild(MatSort) set matSort (sort: MatSort) {
    this.sort = sort
    this.dataSource.sort = sort
  }

  constructor (
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly aybService: AyBService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  ngOnInit (): void {
    this.getAllMenus()
  }
  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  getAllMenus (): void {
    this.aybService
      .queryGetAllKitchenMenus()
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        finalize(() => {
          this.isLoading = false
          this.cdRef.markForCheck()
        })
      )
      .subscribe({
        next: ({ getAllKitchenMenus }) => {
          this.kitchenMenus = getAllKitchenMenus
          this.dataSource.data = this.kitchenMenus
          this.dataSource.sort = this.sort
          this.dataSource.paginator = this.paginator
        },
        error: error => {
          console.error('Error fetching menus:', error)
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron cargar los menús. Inténtalo de nuevo o contacta al soporte.'
          })
        }
      })
  }

  deleteMenu (element: any): void {
    Swal.fire({
      title: '¿Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.isConfirmed) {
        this.aybService
          .mutationDeleteMenu(element.id)
          .pipe(takeUntil(this._unsubscribeOnDestroy$))
          .subscribe(data => {
            console.log(data)
            this.getAllMenus()
            this.cdRef.markForCheck()
          })
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'El registro se eliminó satisfactoriamente.',
          showConfirmButton: false,
          timer: 4000
        })
      }
    })
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value

    this.dataSource.data.forEach((element: { [x: string]: string }) => {
      for (const key in element) {
        if (!element[key] || element[key] === null) {
          element[key] = ''
        }
      }
    })

    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  openDialogAdd (): void {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      nombre: '',
      descripcion: '',
      title: 'Agregar Menú'
    }
    dialogConfig.width = '25rem'

    let dialogRef = this.dialog.open(DialogMenuComponent, dialogConfig)

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(result => {
        console.log('closed')
        if (result == 1) {
          this.getAllMenus()
        }
      })
  }

  navigateToDetalleMenu (menuId: number) {
    this.router
      .navigate([`/detalle-menu/${menuId}`])
      .then(() => console.log('Navigated to Detalle Menu'))
  }
}
